import { useQuery, UseQueryResult } from 'react-query';
import type { HotlinePageData, ResponseFormat } from '../algebra/global';
import { Http } from '../prelude/http';

export const useGetClientInfo = (key: string): UseQueryResult<HotlinePageData> => {
  return useQuery(['client-info', key], () => Http.Request<ResponseFormat<HotlinePageData>>('GET', `/hotlines/api/v1/ingress/clientinfobymsgservicekey.get?id=${key}`).then((res) => res.data), {
    enabled: key !== undefined,
  });
};
